import { ExportInfosBuilder } from './../../model/builder/export-infos.builder';
import { ExportInfos } from './../../model/export-info';
import { DownloadExportService } from './../../service/download-export.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AfterViewInit } from '@angular/core';
import {Observable} from "rxjs";
import {AnonymousSubscription} from "rxjs/Subscription";

@Component({
  selector: 'app-download-export',
  templateUrl: './download-export.component.html',
  styleUrls: ['./download-export.component.css']
})
export class DownloadExportComponent implements OnInit {

  private timerSubscription: AnonymousSubscription;
  private downloadExportSubscription: AnonymousSubscription;
  displayedColumns: string[] = ['select', 'debut', 'fin', 'typeFichier', 'statut'];
  dataSource = new MatTableDataSource<ExportInfos>();
  selection = new SelectionModel<ExportInfos>(true, []);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  pageSizeOptions: number[] = [5, 10, 25, 50, 100];
  pageSize: number = 10;
  numRowsCompleted: number = -1;

  constructor(private downloadExportService: DownloadExportService) {
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    return numSelected === this.numRowsCompleted;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.numRowsCompleted = 0;
      this.dataSource.data.forEach(row => {
        if (!this.isNotCompleted(row)) {
          this.selection.select(row)
          this.numRowsCompleted++;
        }
      });
    }
  }

  ngOnInit() {
    this.downloadExportSubscription = this.downloadExportService.getExportFiles().subscribe(tsExportVOList => {
      let tsExportList = [];
      tsExportVOList.forEach(tsExportVO => {
        tsExportList.push(ExportInfosBuilder.build(tsExportVO));
      });
      this.dataSource = new MatTableDataSource<ExportInfos>(tsExportList);
      this.selection = new SelectionModel<ExportInfos>(true, []);
      this.dataSource.paginator = this.paginator;
      this.subscribeToData();
    });
  }

  public ngOnDestroy(): void {
    if (this.downloadExportSubscription) {
      this.downloadExportSubscription.unsubscribe();
    }
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  refreshData() {
    this.downloadExportSubscription = this.downloadExportService.getExportFiles().subscribe(tsExportVOList => {
      let tsExportList = [];
      tsExportVOList.forEach(tsExportVO => {
        tsExportList.push(ExportInfosBuilder.build(tsExportVO));
      });
      this.dataSource = new MatTableDataSource<ExportInfos>(tsExportList);
      this.selection = new SelectionModel<ExportInfos>(true, []);
      this.dataSource.paginator = this.paginator;
    });
  }

  subscribeToData(): void {
    this.timerSubscription = Observable.timer(10000).first().subscribe(() => {
      if (this.dataSource.data !== null) {
        let tsExportInProgress = this.dataSource.data.filter(e => e.statut == 'EN_PROGRESSION');
        if (tsExportInProgress !== null && tsExportInProgress.length > 0) {
          this.downloadExportService.getExportFiles().subscribe(tsExportVOList => {
            tsExportInProgress.forEach(tsExportInProgressItem => {
              let tsExport = tsExportVOList.filter(tsExportVOListItem =>
                tsExportVOListItem.id === tsExportInProgressItem.id);
              if (tsExport !== null && tsExport.length > 0 && tsExport[0].status !== tsExportInProgressItem.statut) {
                tsExportInProgressItem.statut = tsExport[0].status;
                tsExportInProgressItem.fin = tsExport[0].completed;
              }
            });
            this.subscribeToData();
          });
        }
      }
    });
  }

  download() {
    let fileNames = this.selection.selected.map(s => s.fileName);
    // console.log(fileNames);
    this.downloadExportService.process(fileNames);
  }

  isNotCompleted(row) {
    return row.fileName === undefined || row.statut !== "SUCCESS";
  }

}



// WEBPACK FOOTER //
// ./src/app/view/download-export/download-export.component.ts